var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-sheet',{staticClass:"d-flex",attrs:{"height":"100%"}},[_c('Side'),_c('v-main',{staticClass:"adminCustomStyle",staticStyle:{"background":"#f8f8f8"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }